// extracted by mini-css-extract-plugin
export default {"fullWidth":"Jh-z","hasStyledAspectRatio":"Kh-z"};